import styled, { withTheme } from 'styled-components';
import { ListItem } from '@material-ui/core';

const ListItemPlain = styled(ListItem)`
  background-color: transparent;
  margin-bottom: 0;
  padding: 0 0 2px;
  &.spaced {
    margin-top: 5px;
  }
  span {
    font-size: 16px;
    ${(props) => props.theme.breakpoints.down('md')} {
      font-size: 14px;
    }
    font-family: ${(props) => props.theme.typography.fontFamily};
  }
`;

export default withTheme(ListItemPlain);
